var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-only',[_c('ADialog',{attrs:{"data-test-id":"dialog"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }